var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialDistance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.05548.6491c.17251.17462.19016.44416.05399.6382l-.05828.0689L2.21674 7.119l7.07671.0005c.27615 0 .5.22386.5.5 0 .24546-.17687.4496-.41012.49194l-.08988.00806-7.0767-.0005 5.59441 5.52528c.17463.1725.19557.4418.06177.6375l-.05742.0696c-.1725.17462-.4418.19556-.6375.06177l-.0696-.05743-6.81967-6.7364L7.3484.64482c.19644-.19408.51302-.19216.7071.00428zM22.8222.58685l.0696.05743 6.8197 6.73642-7.06073 6.97451c-.19645.19406-.51303.19212-.70709-.00434-.1725-.17463-.19013-.44417-.05394-.6382l.05828-.0689L28.288 7.38l-6.09896-6.02428c-.17463-.1725-.19557-.4418-.06177-.6375l.05743-.0696c.1725-.17462.4418-.19556.6375-.06177zM17 7c.27614 0 .5.22386.5.5 0 .24546-.17688.4496-.41012.49194L17 8h-5c-.27614 0-.5-.22386-.5-.5 0-.24546.17688-.4496.41012-.49194L12 7h5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialDistance);
export default __webpack_public_path__ + "static/media/social-distance.14683d22.svg";
export { ForwardRef as ReactComponent };